// extracted by mini-css-extract-plugin
module.exports = {"InfoPanel":"InfoPanel_InfoPanel__3nH1A"};